// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"81":"7c982b4c","335":"cb40a4be","787":"3d099ce4"}[chunkId] + ".chunk.js";
};